import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 60000 });

// Cache-busting interceptor: append a fresh nonce to every GET so neither the
// browser nor any intermediary CDN can serve stale data after an Airtable sync.
client.interceptors.request.use((config) => {
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _ts: Date.now() };
  }
  return config;
});

export const api = {
  syncStatus: () => client.get("/sync/status").then((r) => r.data),
  triggerSync: () => client.post("/sync").then((r) => r.data),
  filters: () => client.get("/filters").then((r) => r.data),
  kpis: (params) => client.get("/kpis", { params }).then((r) => r.data),
  revenueTrend: (params) => client.get("/charts/revenue-trend", { params }).then((r) => r.data),  byVertical: (params) => client.get("/charts/by-vertical", { params }).then((r) => r.data),
  byProgram: (params) => client.get("/charts/by-program", { params }).then((r) => r.data),
  bySalesperson: (params) => client.get("/charts/by-salesperson", { params }).then((r) => r.data),
  byClientType: (params) => client.get("/charts/by-client-type", { params }).then((r) => r.data),
  byProgramType: (params) => client.get("/charts/by-program-type", { params }).then((r) => r.data),
  paymentStatus: (params) => client.get("/charts/payment-status", { params }).then((r) => r.data),
  students: (params) => client.get("/students", { params }).then((r) => r.data),
  partnerships: (params) => client.get("/students", { params: { ...(params || {}), kinds: "partnership" } }).then((r) => r.data),
  studentsOnly: (params) => client.get("/students", { params: { ...(params || {}), kinds: "student" } }).then((r) => r.data),
  payments: (params) => client.get("/payments", { params }).then((r) => r.data),
  dataHygiene: () => client.get("/data-hygiene").then((r) => r.data),
  drilldownRevenue: (params) => client.get("/drilldown/revenue", { params }).then((r) => r.data),
  drilldownOutstanding: (params) => client.get("/drilldown/outstanding", { params }).then((r) => r.data),
  leaderboard: (params) => client.get("/leaderboard", { params }).then((r) => r.data),
};

export const formatINR = (n) => {
  if (n == null || isNaN(n)) return "—";
  const v = Number(n);
  if (v >= 1e7) return `₹${(v / 1e7).toFixed(2)}Cr`;
  if (v >= 1e5) return `₹${(v / 1e5).toFixed(2)}L`;
  if (v >= 1e3) return `₹${(v / 1e3).toFixed(1)}K`;
  return `₹${v.toFixed(0)}`;
};

export const formatNum = (n) => {
  if (n == null || isNaN(n)) return "—";
  return Number(n).toLocaleString("en-IN");
};

export const formatPct = (n) => {
  if (n == null || isNaN(n)) return "—";
  return `${Number(n).toFixed(1)}%`;
};
